/**
 * Created by tong on 2018/2/2.
 */
import React from 'react';

class PurchaseUnit extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
}
export default PurchaseUnit;


// WEBPACK FOOTER //
// ./src/routes/purchaseUnit/index.js